import React from 'react';
import { Link } from 'react-router-dom';

import './NotFound.scss';

import commonConstant from '../../common/_commonConstant';

export default () => (
  <div className="NotFound">
    <div className="box-page">
      <img className="logo" src={commonConstant.ezyParkLogo} alt="ezyParkLogo" />
      <div className="oops">Oops!</div>
      <div className="description" id="error-page-not-found">
        We’re sorry, The page you requested
        could not be found. Please go back to
        homepage or contact customer service.
      </div>
      <Link id="btn-ok" className="btn back btn-primary" to={commonConstant.pathCheckRedirect}>Back to Home</Link>
    </div>
  </div>
);
